import {
  formatBytes,
  useTranslation,
  UploadButton,
  Icon,
  NOOP,
} from '@testsigma/atoms';
import { useState, useEffect } from 'react';

import WdaService from '../ios-wda-services';
import { WdaProfile } from '@models/wda-profile.model';

export const WdaStep2 = ({
  setIsStep2Valid,
  setFormData,
  setEnableSave,
  setIsLoadingStep2 = NOOP,
}) => {
  const [uploadedFileName, setUploadedFileName] = useState<string>();
  const [isFileUploading, setIsFileUploading] = useState<boolean>(false);
  const [fileSize, setFileSize] = useState(null);
  useEffect(() => {
    const string = window.location.pathname;
    if (string.includes('/edit')) {
      const match = string.match(/\/(\d+)$/);
      if (match) {
        WdaService.show(match[1])
          .then((res: WdaProfile) => {
            setUploadedFileName(res.fileName);
            setIsStep2Valid(true);
            setFileSize(formatBytes(res.wdaFileSize));
          })
          .finally(() => {
            setTimeout(() => {
              setIsLoadingStep2(false);
            }, 1000);
          });
      }
    } else {
      setIsLoadingStep2(false);
    }
  }, []);

  const onFileRemove = () => {
    setIsStep2Valid(false);
    setUploadedFileName(null);
    setIsFileUploading(false);
  };
  const { t } = useTranslation();
  const onFileSelect = (e) => {
    setIsFileUploading(true);
    setUploadedFileName(e.target.files[0].name);
    setFileSize(formatBytes(e.target.files[0].size));
    setIsStep2Valid(true);
    const formData = new FormData();
    formData.append('fileName', e.target.files[0].name);
    formData.append('fileContent', e.target.files[0]);
    setFormData(formData);
    setIsFileUploading(false);
    setEnableSave(true);
  };
  return (
    <div className='flex pb-8 flex-row'>
      <div className='w-1/10'>
        <div
          className={`flex h-6 w-6 items-center rounded-full ${'bg-primary-1000'} `}>
          <h1 className={`mx-auto text-sm font-semibold ${' text-white'}`}>
            2
          </h1>
        </div>
      </div>
      <div className='w-9/10'>
        <div className='pl-6'>
          <p className={`text-sm font-semibold text-unique-600 $`}>
            {t('settings.ios_settings.wda.step2.heading')}
          </p>
          <p
            className={`text-xs font-normal text-secondary-500 pt-2 `}
            dangerouslySetInnerHTML={{
              __html: t('settings.ios_settings.wda.step2.value'),
            }}
          />
          <UploadButton
            fileSize={fileSize}
            accept='.ipa'
            className={`mt-4 ${
              !uploadedFileName
                ? 'text-white !py-2 !px-3 !h-7 bg-primary-1000'
                : ''
            }`}
            onFileSelect={onFileSelect}
            onFileRemove={onFileRemove}
            uploadedFileName={uploadedFileName}
            isFileUploading={isFileUploading}
            displayWithIconFileSize={true}
            label={
              <div className='flex'>
                <Icon name='upload-up' className='mr-1 text-base' />
                <p className='text-xs  text-white'>
                  {t('settings.ios_settings.wda.upload.button')}
                </p>
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};
